import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useEffect } from "preact/hooks";

import Cookies from "js-cookie";

import quilterFunctions from "../../../../helpers/quilter-functions";
import { IResult } from "../Result";

export interface IFasterOnlineProps {
  id: string;
  item: IResult;
  show: boolean;
  changeShowModal: any;
}

const FasterOnline: FunctionComponent<IFasterOnlineProps> = ({ id, item, show, changeShowModal }) => {
  const {
    fasterOnlineModalCtaText,
    fasterOnlineModalPrimaryText,
    fasterOnlineModalTitle,
    fasterOnlineSecondaryText,
    fasterOnlineUrls,
    fasterOnlineOpenInSameTab,
    fasterOnlineCtaOpenInSameTab,
  } = item;

  const roleId = Cookies.get("Role");
  const roleLink = fasterOnlineUrls?.filter((x) => x.roleId == roleId);
  const documentTarget = fasterOnlineOpenInSameTab ? "_self" : "_blank";
  const ctaTarget = fasterOnlineCtaOpenInSameTab ? "_self" : "_blank";

  useEffect(() => {
    if (show) {
      quilterFunctions.openModal("#modal" + id);
    } else {
      quilterFunctions.closeModal("#modal" + id);
    }
  });

  return (
    <div
      className="dialog dialog-with-x"
      id={`modal${id}`}
      aria-hidden="false"
      aria-labelledby="modal-title-faster-online"
      aria-describedby="modal-description-fast-online"
      role="dialog"
    >
      <div className="dialog__overlay">
        <dialog
          open={show}
          className="dialog__container"
        >
          <article
            className="dialog__content"
            role="document"
          >
            <header className="dialog__header skin--strong js-modal-focusable js-modal-header">
              {fasterOnlineModalTitle && (
                <h1
                  className="dialog__title"
                  id="modal-title-faster-online"
                >
                  {fasterOnlineModalTitle}
                </h1>
              )}
            </header>

            <button
              className="unbutton dialog__close js-modal-close"
              aria-label="Close"
              onClick={(e: any) => changeShowModal(false)}
            ></button>

            <div className="dialog__section dialog__body--min-height dialog__cta skin richtext-content text-center">
              {fasterOnlineModalPrimaryText && <h2 className="modal__cta-header">{fasterOnlineModalPrimaryText}</h2>}
              {fasterOnlineModalCtaText && roleLink && roleLink[0] && fasterOnlineModalCtaText && (
                <form
                  action={roleLink[0].fasterOnlineUrl || "#"}
                  target={ctaTarget}
                >
                  <button
                    className="button button--primary button--arrow dialog__btn"
                    type="submit"
                  >
                    {fasterOnlineModalCtaText}
                  </button>
                </form>
              )}
            </div>

            <footer className="dialog__footer dialog__footer--with-divider skin--faint">
              {fasterOnlineSecondaryText && <p id="modal-description-fast-online">{fasterOnlineSecondaryText}</p>}
              {item.title && item.contentUrl && (
                <p>
                  <a
                    href={item.contentUrl}
                    className="link"
                    target={documentTarget}
                  >
                    {item.title}
                  </a>
                </p>
              )}
            </footer>
          </article>
        </dialog>
      </div>
    </div>
  );
};

export default FasterOnline;
